import { Injectable } from '@angular/core';
import { ActivationStart, Params, Router } from '@angular/router';
import { BehaviorSubject, Observable, filter, map, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SimpleFlowDetectionService {
  private readonly simpleFlowToken = 'simpleFlow';
  private isSimpleFlowSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private router: Router) {
    this.figureOutSimpleFlowFromUrlParams$();
  }

  isSimpleFlow$(): Observable<boolean> {
    return this.isSimpleFlowSubject$.asObservable();
  }

  private figureOutSimpleFlowFromUrlParams$(): void {
    this.collectParams$()
      .pipe(
        filter((params: Params) => Boolean(params?.simpleFlowSalonId)),
        take(1),
        tap(() => {
          sessionStorage.setItem(this.simpleFlowToken, 'true');
          this.isSimpleFlowSubject$.next(true);
        }))
      .subscribe();
  }

  private collectParams$(): Observable<Params> {
    return this.router.events
      .pipe(
        filter(e => (e instanceof ActivationStart)),
        map(e => e instanceof ActivationStart ? e.snapshot.params : {}),
      );
  }

}
